<template>
  <div class="text-center h-100 d-flex align-items-center justify-content-center flex-column">
    <i class="text-muted text-2xl fas fa-mug-hot opacity-75 mt-0 mb-3"></i>
    <h5 class="text-xs text-muted text-monospace text-uppercase mb-4">{{$t("Components.EmptyInfoBlock.NoData")}}</h5>

    <p class="text-xxs opacity-75 mb-0" v-html='$t("Components.EmptyInfoBlock.Text")'></p>
  </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "EmptyInfoBlock"
})
</script>

<style scoped>

</style>